import { images } from '@constants/images';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ color = 'light' }: { color?: string }) => {
  const navigate = useNavigate();

  const handleBackButton = () => {
    navigate(-1);
  };

  return (
    <button onClick={handleBackButton}>
      <img
        src={color === 'light' ? images.backWhite : images.back}
        alt="back-button"
      />
    </button>
  );
};

export default BackButton;
